import globals from '@/globals';

export default (() => {
  const DeviceKeyIdentifier = globals().facetecDeviceKeyIdentifier;
  const ProductionKeyText = {
    domains: globals().facetecProductionKeyTextDomains,
    expiryDate: globals().facetecProductionKeyTextExpiryDate,
    key: globals().facetecProductionKeyTextKey,
  };

  const BaseURL = globals().apiUrl;

  const PublicFaceScanEncryptionKey = '-----BEGIN PUBLIC KEY-----\n'
    + 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5PxZ3DLj+zP6T6HFgzzk\n'
    + 'M77LdzP3fojBoLasw7EfzvLMnJNUlyRb5m8e5QyyJxI+wRjsALHvFgLzGwxM8ehz\n'
    + 'DqqBZed+f4w33GgQXFZOS4AOvyPbALgCYoLehigLAbbCNTkeY5RDcmmSI/sbp+s6\n'
    + 'mAiAKKvCdIqe17bltZ/rfEoL3gPKEfLXeN549LTj3XBp0hvG4loQ6eC1E1tRzSkf\n'
    + 'GJD4GIVvR+j12gXAaftj3ahfYxioBH7F7HQxzmWkwDyn3bqU54eaiB7f0ftsPpWM\n'
    + 'ceUaqkL2DZUvgN0efEJjnWy5y1/Gkq5GGWCROI9XG/SwXJ30BbVUehTbVcD70+ZF\n'
    + '8QIDAQAB\n'
    + '-----END PUBLIC KEY-----';

  let currentCustomization;

  function retrieveConfigurationWizardCustomization(FaceTecSDK) {
    const sdkImageDirectory = '../../../../core-sdk/FaceTec_images-ame';

    // For Color Customization
    const outerBackgroundColor = '#ffffff';
    const frameColor = '#ffffff';
    const borderColor = '#ffffff';
    const ovalColor = '#ED0059';
    const dualSpinnerColor = '#ED0059';
    const textColor = '#ED0059';
    const buttonAndFeedbackBarColor = '#ED0059';
    const buttonAndFeedbackBarTextColor = '#ffffff';
    const buttonColorHighlight = '#8D0019';
    const buttonColorDisabled = '#dfe3e8';

    // For Frame Corner Radius Customization
    const frameCornerRadius = '20px';
    const feedbackCornerRadius = '6px';

    // For Cancel Button Customization
    const cancelButtonImage = `${sdkImageDirectory}FaceTec_cancel.png`;
    const cancelButtonLocation = FaceTecSDK.FaceTecCancelButtonLocation.TopRight;

    // AQUI PRA DESATIVAR O SECURITY
    const securityWatermarkImage = FaceTecSDK.FaceTecSecurityWatermarkImage.FaceTec_ZoOm;

    // Set a default customization
    const defaultCustomization = new FaceTecSDK.FaceTecCustomization();

    // Set Frame Customization
    defaultCustomization.frameCustomization.borderCornerRadius = frameCornerRadius;
    defaultCustomization.frameCustomization.backgroundColor = frameColor;
    defaultCustomization.frameCustomization.borderColor = borderColor;

    // Set Overlay Customization
    defaultCustomization.overlayCustomization.backgroundColor = outerBackgroundColor;
    defaultCustomization.overlayCustomization.brandingImage = `${sdkImageDirectory}/FaceTec_your_app_logo.png`;
    defaultCustomization.overlayCustomization.showBrandingImage = true;

    // Set Guidance Customization
    defaultCustomization.guidanceCustomization.backgroundColors = frameColor;
    defaultCustomization.guidanceCustomization.foregroundColor = textColor;
    defaultCustomization
      .guidanceCustomization
      .buttonBackgroundNormalColor = buttonAndFeedbackBarColor;
    defaultCustomization.guidanceCustomization.buttonBackgroundDisabledColor = buttonColorDisabled;
    defaultCustomization
      .guidanceCustomization
      .buttonBackgroundHighlightColor = buttonColorHighlight;
    defaultCustomization
      .guidanceCustomization
      .buttonTextNormalColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .guidanceCustomization
      .buttonTextDisabledColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .guidanceCustomization
      .buttonTextHighlightColor = buttonAndFeedbackBarTextColor;
    defaultCustomization.guidanceCustomization.retryScreenImageBorderColor = borderColor;
    defaultCustomization.guidanceCustomization.retryScreenOvalStrokeColor = borderColor;

    // Set Oval Customization
    defaultCustomization.ovalCustomization.strokeColor = ovalColor;
    defaultCustomization.ovalCustomization.progressColor1 = dualSpinnerColor;
    defaultCustomization.ovalCustomization.progressColor2 = dualSpinnerColor;

    // Set Feedback Customization
    defaultCustomization.feedbackCustomization.backgroundColor = buttonAndFeedbackBarColor;
    defaultCustomization.feedbackCustomization.textColor = buttonAndFeedbackBarTextColor;
    defaultCustomization.feedbackCustomization.shadow = 'unset';
    defaultCustomization.feedbackCustomization.cornerRadius = feedbackCornerRadius;

    // Set Cancel Customization
    defaultCustomization.cancelButtonCustomization.customImage = cancelButtonImage;
    defaultCustomization.cancelButtonCustomization.location = cancelButtonLocation;

    // Set Security Watermark Customization
    defaultCustomization
      .securityWatermarkCustomization
      .setSecurityWatermarkImage(securityWatermarkImage);

    // Remove voice
    defaultCustomization.vocalGuidanceCustomization.mode = 2;

    // Set Result Screen Customization
    defaultCustomization.resultScreenCustomization.backgroundColors = frameColor;
    defaultCustomization.resultScreenCustomization.foregroundColor = textColor;
    defaultCustomization
      .resultScreenCustomization
      .activityIndicatorColor = buttonAndFeedbackBarColor;
    defaultCustomization
      .resultScreenCustomization
      .resultAnimationBackgroundColor = buttonAndFeedbackBarColor;
    defaultCustomization
      .resultScreenCustomization
      .resultAnimationForegroundColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .resultScreenCustomization
      .uploadProgressFillColor = buttonAndFeedbackBarColor;

    this.currentCustomization = defaultCustomization;

    // Set ID Scan Customization
    defaultCustomization.idScanCustomization.selectionScreenBackgroundColors = frameColor;
    defaultCustomization.idScanCustomization.selectionScreenForegroundColor = textColor;
    defaultCustomization.idScanCustomization.reviewScreenBackgroundColors = frameColor;
    defaultCustomization
      .idScanCustomization
      .reviewScreenForegroundColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .idScanCustomization
      .reviewScreenTextBackgroundColor = buttonAndFeedbackBarColor;
    defaultCustomization
      .idScanCustomization
      .captureScreenForegroundColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .idScanCustomization
      .captureScreenTextBackgroundColor = buttonAndFeedbackBarColor;
    defaultCustomization
      .idScanCustomization
      .buttonBackgroundNormalColor = buttonAndFeedbackBarColor;
    defaultCustomization.idScanCustomization.buttonBackgroundDisabledColor = buttonColorDisabled;
    defaultCustomization.idScanCustomization.buttonBackgroundHighlightColor = buttonColorHighlight;
    defaultCustomization.idScanCustomization.buttonTextNormalColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .idScanCustomization
      .buttonTextDisabledColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .idScanCustomization
      .buttonTextHighlightColor = buttonAndFeedbackBarTextColor;
    defaultCustomization.idScanCustomization.captureScreenBackgroundColor = frameColor;
    defaultCustomization.idScanCustomization.captureFrameStrokeColor = borderColor;

    // Set Initial Loading Customization
    defaultCustomization
      .initialLoadingAnimationCustomization
      .backgroundColor = buttonAndFeedbackBarTextColor;
    defaultCustomization
      .initialLoadingAnimationCustomization
      .foregroundColor = buttonAndFeedbackBarColor;

    return defaultCustomization;
  }

  const wasSDKConfiguredWithConfigWizard = true;

  return {
    DeviceKeyIdentifier,
    ProductionKeyText,
    BaseURL,
    PublicFaceScanEncryptionKey,

    retrieveConfigurationWizardCustomization,
    currentCustomization,

    wasSDKConfiguredWithConfigWizard,
  };
})();
